<template>
  <div :ref="'scroll-container-' + containerKey" id="scroll-bottom" @scroll="e => onScroll(e.target)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    containerKey: {
      type: String,
      default: () => 'default'
    },
    onScrollBottom: {
      type: Function,
      required: true
    },
    deviation: {
      type: Number,
      default: () => 0
    }
  },
  data () {
    return {
      currentScroll: 0
    }
  },
  async mounted () {
    this.onScroll(this.$refs['scroll-container-' + this.containerKey], true)
  },
  methods: {
    async onScroll (element, init = false) {
      if (element.scrollTop >= element.scrollHeight - element.offsetHeight - (init ? 0 : this.deviation) && (element.scrollTop > this.currentScroll || this.currentScroll === 0)) {
        this.currentScroll = element.scrollHeight - element.offsetHeight
        let result = await this.onScrollBottom()
        if (result !== false && element.scrollHeight === element.offsetHeight) {
          this.onScroll(element)
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
#scroll-bottom
  flex: 1
  width: 100%
  height: 100%
  overflow: auto
</style>



// WEBPACK FOOTER //
// src/components/tool/scrollBottom.vue